<div class="app__router" #mainDiv>
  <div #spinner class="spinner-show">
    <app-loader-spinner-overlay></app-loader-spinner-overlay>
  </div>
  <router-outlet #outlet="outlet" [@routeFadeAnimation]="prepareRoute(outlet)"></router-outlet>
</div>

<!-- Live Chat -->
@switch (liveChatType) {
  <!-- Facebook Chat -->
  @case (liveChat.FACEBOOK) {
    <div id="fb-customer-chat" class="fb-customerchat" #chat></div>
  }
  @case (liveChat.TIDIO) {
    <div #chat></div>
  }
}

<!-- Company Logo on login pages -->
<app-logo [isLoginSmall]="true"></app-logo>
